import { Login } from '@getvim/vim-connect';
import { useCallback, useState } from 'react';
import { seamlessApiClient } from '../api/seamlessApiClient';
import {
  Credentials,
  ExpiredPasswordError,
  InternalServerError,
  OtpLoginInput,
  SeamlessCredentials,
} from '../types';

export const useLogin = () => {
  const [isLoading, setIsLoading] = useState(false);

  const login = useCallback(
    async (input: {
      organizationId: number;
      vimCredentials?: Credentials;
      otpLoginInput?: OtpLoginInput;
      seamlessLoginCredentials?: SeamlessCredentials;
      ehrCredentials: Credentials;
    }) => {
      try {
        setIsLoading(true);
        return await seamlessApiClient.initialLogin(input);
      } catch (error) {
        const axiosError = error as {
          response?: { data?: { message?: string }; status?: number };
        };

        const response = axiosError.response;

        if (response?.data?.message === 'Password has expired') {
          throw new ExpiredPasswordError('Password has expired');
        }

        if (response?.status === 500) {
          throw new InternalServerError(Login.INTERNAL_SERVER_ERROR_MESSAGE);
        }

        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    [],
  );

  return {
    login,
    loading: isLoading,
  };
};
